import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { Edit } from '../../helpers/icon-dictionary';
import css from './index.scss';
import messages from './messages';
import Button from '../../components/button/index';
import AssignedTeacherList from '../../components/assigned-teacher-list/index';

const AssignedTeacher = ({
    handleOnTeacherUnassign,
    intl,
    showModal,
    teachers,
    handleOnUnassignConfirm,
    handleOnCloseModal,
    isUserOperationModalOpen,
    isLoading,
    teachersOperationSuccessConfirmation,
    handleOnPrintTeacherSignInCard,
    downloadingTeachersIds,
    handleOnAssignTeacher
}) => (
    <div className={css.assignedTeacherComponent}>
        <div className={css.title}>{intl.formatMessage(messages.assignedTeachers)}</div>
        <AssignedTeacherList
            downloadingTeachersIds={downloadingTeachersIds}
            handleOnCloseModal={handleOnCloseModal}
            handleOnPrintTeacherSignInCard={handleOnPrintTeacherSignInCard}
            handleOnTeacherUnassign={handleOnTeacherUnassign}
            handleOnUnassignConfirm={handleOnUnassignConfirm}
            isLoading={isLoading}
            isUserOperationModalOpen={isUserOperationModalOpen}
            showModal={showModal}
            teachers={teachers}
            teachersOperationSuccessConfirmation={teachersOperationSuccessConfirmation} />
        <div className={css.footer}>
            <Button
                containerClassName={css.assignTeacher}
                handleOnClick={handleOnAssignTeacher}
                icon={Edit}
                iconClassName={css.icon}
                label={intl.formatMessage(messages.assignTeacher)}
            />
        </div>
    </div>
);

AssignedTeacher.propTypes = {
    intl: intlShape.isRequired,
    teachers: PropTypes.array,
    handleOnTeacherUnassign: PropTypes.func,
    showModal: PropTypes.bool,
    handleOnUnassignConfirm: PropTypes.func,
    isUserOperationModalOpen: PropTypes.bool,
    handleOnCloseModal: PropTypes.func,
    isLoading: PropTypes.bool,
    teachersOperationSuccessConfirmation: PropTypes.func,
    handleOnPrintTeacherSignInCard: PropTypes.func,
    downloadingTeachersIds: PropTypes.object,
    handleOnAssignTeacher: PropTypes.func
};

export default injectIntl(styleable(css)(AssignedTeacher));



// WEBPACK FOOTER //
// ./app/components/assigned-teacher-class/index.js